export const environment = {
  production: true,
  apiUrl: 'https://api-managment-digitalizcija.azure-api.net/isbpwebapi-test/',
  keycloak: {
    clientId: 'isbp-employees-bike',
    realm: 'isbp-test',
    url: ' https://wa-euwe-keycloak-test-01.azurewebsites.net/',
    logoutUrl: 'https://zealous-coast-0f7b7c803.6.azurestaticapps.net/logout',
  },
  useApim: true,
  secret: '4832f02c7fcd44658fecdc7cbbce42be',
};
